module.exports = __webpack_public_path__ + "img/avatar-00.4cf0250b.png";